import { MeasureValues, useModelService } from 'services/model/model.service';
import { MeasureBreakdownList, MeasureBreakdownRow } from 'components/profitability/MeasureBreakdownList';

interface CostOfGoodsListProps {
  values?: MeasureValues;
  compareValues?: MeasureValues;
  isComparisonActive: boolean;
}

export function CostOfGoodsList({
  values = undefined,
  compareValues = undefined,
  isComparisonActive,
}: CostOfGoodsListProps) {
  const { getMeasures, getMeasuresByMetrics } = useModelService();
  const [omv, avgSoldPrice, avgPriceMarkdown] = getMeasuresByMetrics(
    ['itemSlsOmvVal', 'itemSlsGmvVal', 'itemSlsMkdRate'],
    'OD'
  );
  const [cogRate] = getMeasures(['netSlsCogRateExtExpOD']);
  const [itemCogVal] = getMeasures(['itemNetSlsCogValExtExpOD']);
  const [cogVal] = getMeasures(['netSlsCogValExtExpOD']);

  const rows: MeasureBreakdownRow[] = [
    { labelMeasure: omv, perItemMeasure: omv },
    { labelMeasure: avgSoldPrice, perItemMeasure: avgSoldPrice },
    { labelMeasure: avgPriceMarkdown, perItemMeasure: avgPriceMarkdown },
    {
      labelMeasure: cogVal,
      perItemMeasure: itemCogVal,
      totalMeasure: cogVal,
      shareMeasure: cogRate,
    },
  ];

  return (
    <MeasureBreakdownList
      titleMeasure={cogVal}
      rows={rows}
      values={values}
      compareValues={compareValues}
      isComparisonActive={isComparisonActive}
      testId="profitability-cost-of-goods-list"
    />
  );
}
